import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';
import { useCookieConsent } from '../hooks/useCookieConsent';
import { useTranslation } from '../hooks/useTranslation';
import { useDesignColors } from '../hooks/useDesignColors';

export function CookieConsent() {
  const { consent, updateConsent } = useCookieConsent();
  const { t } = useTranslation();
  const { colors } = useDesignColors();
  const [show, setShow] = useState(false);

  useEffect(() => {
    // Ne pas afficher la bannière dans une iframe ou si le paramètre URL 'embedded' est présent
    const isInIframe = window.self !== window.top;
    const isEmbedded = new URLSearchParams(window.location.search).get('embedded') === 'true';
    const isWidget = window.location.pathname.includes('/widget');
    
    if (isInIframe || isEmbedded || isWidget) {
      setShow(false);
      return;
    }

    // Show popup if consent hasn't been given yet
    if (consent === null) {
      setShow(true);
    }
  }, [consent]);

  // Ne pas rendre du tout si on ne doit pas l'afficher
  if (!show) return null;

  return (
    <div 
      className="fixed bottom-0 left-0 right-0 bg-black/95 backdrop-blur-xl border-t border-white/10 p-4 z-50"
      data-testid="cookie-consent"
    >
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
        <div className="flex-1">
          <p className="text-white text-sm mb-2">
            {t('cookies.notice')}
          </p>
          <p className="text-gray-400 text-xs">
            {t('cookies.description')}
          </p>
        </div>
        
        <div className="flex flex-col sm:flex-row gap-2 w-full sm:w-auto">
          <button
            onClick={() => {
              updateConsent({
                necessary: true,
                analytics: false,
                marketing: false
              });
              setShow(false);
            }}
            className="w-full sm:w-auto text-sm px-4 py-2 rounded-lg bg-white/5 text-gray-300 hover:bg-white/10 transition-colors whitespace-nowrap"
          >
            {t('cookies.essential')}
          </button>
          
          <button
            onClick={() => {
              updateConsent({
                necessary: true,
                analytics: true,
                marketing: true
              });
              setShow(false);
            }}
            style={{
              background: `linear-gradient(135deg, ${colors.gradientStart}, ${colors.gradientEnd})`,
              opacity: 0.9
            }}
            className="w-full sm:w-auto text-sm px-4 py-2 rounded-lg text-white hover:opacity-100 transition-opacity whitespace-nowrap"
          >
            {t('cookies.accept')}
          </button>

          <button
            onClick={() => setShow(false)}
            className="absolute sm:static right-2 top-2 text-gray-400 hover:text-white transition-colors p-2"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
      </div>
    </div>
  );
}